import { CallBackProps, Step } from 'react-joyride'

export enum ONBOARDING_JOYRIDE_STEP_TYPE {
  GENERAL = 'GENERAL',
  TARGET = 'TARGET',
}

export interface IOnboardingJoyrideStep extends Omit<Step, 'title' | 'content'> {
  content: string
  imageUri?: string
  redirection?: {
    next?: string
    origin?: string
  }
  // Redefine Joyride Step props
  title: string
  type: keyof typeof ONBOARDING_JOYRIDE_STEP_TYPE
  wait?: boolean
}

export type IOnboardingCustomJoyrideStep =
  | {
      content: string
      imageUri?: string
      placement: 'center'
      redirection?: {
        next?: string
        origin?: string
      }
      target: '#root'
      title: string
      type: 'GENERAL'
      wait?: boolean
    }
  | {
      content: string
      imageUri?: string
      redirection?: {
        next?: string
        origin?: string
      }
      target: Step['target']
      title: string
      type: 'TARGET'
      wait?: boolean
    }

export interface ICustomCallBackProps extends CallBackProps {
  step: IOnboardingJoyrideStep
}
